module.exports = __webpack_public_path__ + "media/images/pragma-529efd9e280b1c62b6ca7d48989ffaa2.svg";